<div class="product-references">
  <cx-carousel [title]="title$ | async"
    [items]="items$ | async"
    [template]="carouselItem"
    class="product-references__carousel"
    [itemWidth]="getItemWidth()">
  </cx-carousel>

  <ng-template #carouselItem let-item="item">
    <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl"
      class="product-references__carousel-item-anchor">
      <cx-media [container]="item.images?.PRIMARY" format="product"></cx-media>
      <h4 class="product-references__carousel-item-title">{{ item.name }}</h4>
      @if (showSummary === 'true') {
        <p class="product-references__carousel-item-summary">
          {{ item.summary }}
        </p>
      }
      <div class="product-references__carousel-item-price price">{{ item.ekPrice?.formattedValue }}</div>
    </a>
  </ng-template>
</div>
